import { FunctionComponent } from 'react'
import Title from '@/components/_custom/Title/title'
import styles from './planningKPI.module.scss'
import { useTranslation } from 'react-i18next'
import { PlanningKPIData } from '../hooks/usePlanningKPI.ts'
import { PlanningTabsState } from '@/hooks/usePlanningRights.ts'
import ParentKPI from './parentKPI.tsx'
import RegularKPI from './regularKPI.tsx'
import OccasionalKPI from './occasionalKPI.tsx'
import StaffKPI from './staffKPI.tsx'
import GlobalKPI from './globalKPI.tsx'

interface PlanningKPIProps {
    planningTabs: PlanningTabsState
    isParent: boolean
    kpi: PlanningKPIData
    mobileView?: boolean
    merger: boolean
    filterEvents: (filters: string[]) => void
}

const PlanningKPI: FunctionComponent<PlanningKPIProps> = ({
    planningTabs,
    isParent,
    kpi,
    mobileView = false,
    merger,
    filterEvents
}: PlanningKPIProps) => {
    const { t } = useTranslation()

    return (
        <>
            {!mobileView && <Title text={t('myIndicators')} className={styles.Title} />}
            {planningTabs.isParentTab && (
                <ParentKPI
                    filterEvents={filterEvents}
                    isParent={isParent}
                    validatedHours={kpi.validatedHours}
                    availableHours={kpi.availableHours}
                />
            )}
            {planningTabs.isRegularTab && (
                <RegularKPI
                    planningActiveTab={planningTabs.activeTabId}
                    filterEvents={filterEvents}
                    isParent={isParent}
                    regularRequest={kpi.regularRequest}
                    regularSlot={kpi.regularSlot}
                    absence={kpi.absence}
                />
            )}
            {planningTabs.isOccasionalTab && (
                <OccasionalKPI
                    planningActiveTab={planningTabs.activeTabId}
                    filterEvents={filterEvents}
                    isParent={isParent}
                    merger={merger}
                    requestedHours={kpi.requestedHours}
                    scheduledHours={kpi.scheduledHours}
                    availableHours={kpi.availableHours}
                    validatedHours={kpi.validatedHours}
                />
            )}
            {planningTabs.isStaffTab && (
                <StaffKPI
                    filterEvents={filterEvents}
                    staffHoursInSection={kpi.staffHoursInSection}
                    staffHoursNotInSection={kpi.staffHoursNotInSection}
                    staffHoursHoliday={kpi.staffHoursHoliday}
                    staffHoursTraining={kpi.staffHoursTraining}
                    isParent={isParent}
                />
            )}
            {planningTabs.isGlobalTab && (
                <GlobalKPI
                    successRate={kpi.successRate}
                    warningRate={kpi.warningRate}
                    errorRate={kpi.errorRate}
                    isParent={isParent}
                />
            )}
        </>
    )
}

export default PlanningKPI
